import { flex } from '@/styles/minix';
import styled from 'styled-components';

export const LoginWrap = styled.div`
	margin: auto;
	padding-top: 140px;
	position: relative;
	.switch-button {
		position: absolute;
		top: 30px;
		right: 30px;
		height: 38px;
		background: #f4f5f7;
		border-radius: 2px;
		border: 1px solid #dfe1e6;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
		color: #172b4d;
		font-size: 16px;
		padding-left: 16px;
		padding-right: 18px;
		> img {
			margin-left: 8px;
			vertical-align: baseline;
		}
	}
`;

export const HeaderCSS = styled.div`
	${flex('row', 'center')}
	.title {
		font-size: 40px;
		font-weight: 600;
		color: #172b4d;
		margin-left: 10px;
	}
`;
export const FormWrap = styled.div`
	margin: 22px auto;
	width: 500px;
	background: #ffffff;
	border-radius: 5px;
	border: 1px solid #cccccc;
	padding: 24px;
	.form-title {
		color: #344563;
		font-size: 18px;
		border-bottom: 1px solid #ebecf0;
		padding-bottom: 12px;
		font-weight: 500;
		margin-bottom: 24px;
	}
	.form-item {
		${flex('row', 'center')}
	}
	label {
		color: #6c788c;
		font-size: 12px;
	}
	.ant-form-item {
		/* margin-bottom: 14px; */
	}
	.form-getcode {
		margin-left: 8px;
	}
	.ant-form {
		padding-right: 24px;
	}
	.ant-select {
		width: 80px;
	}
	.ant-input {
		:hover {
			background: #f4f5f7;
			border-radius: 2px;
			border: 1px solid #ebecf0;
		}
	}
	.form-tip {
		margin-top: -14px;
		color: #a9adba;
		font-size: 12px;
	}
	.form-btns {
		margin-top: 22px;
	}
`;

export const LoginPage = styled.div`
	height: 100vh;
	${flex('column', 'center', 'center')}
`;

export const FormCSS = styled.div`
	width: 500px;
	margin: 22px auto;
	background: #ffffff;
	border-radius: 6px;
	border: 1px solid #cccccc;
	margin-top: 26px;
	box-sizing: border-box;
	padding: 28px 0 17px 0;

	.form-title {
		width: calc(100% - 56px);
		font-size: 20px;
		font-weight: 500;
		color: #344563;
		padding-bottom: 14px;
		border-bottom: 1px solid #ebecf0;
		box-sizing: border-box;
		margin-left: 28px;
		display: flex;
		align-items: center;
		> img {
			margin-right: 10px;
		}
	}
	.form-back-icon {
		cursor: pointer;
	}
	// 表单样式
	.ant-form {
		margin-top: 28px;
		padding: 0 62px;
		label {
			font-size: 12px;
			color: #344563;
		}
		.ant-checkbox {
			top: 0;
		}

		.ant-checkbox-wrapper {
			align-items: center;
		}
		.form-btns {
			margin-top: 24px;
		}

		.ant-form-item {
			margin-bottom: 14px;
		}

		.ant-form-item-required {
			font-size: 14px;
			color: #6c788c;
		}
		.ant-form-item-label
			> label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
			content: '';
		}
		.ant-form-item-label {
			text-align: center;
		}
	}
`;
